var _circle, _circle2, _circle3, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 12,
    r: 0
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "0;h.end",
    attributeName: "r",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "0;3",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "b.end",
    attributeName: "cx",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "4;12",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "d.end",
    attributeName: "cx",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "12;20",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "g",
    begin: "f.end",
    attributeName: "r",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "3;0",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "h",
    begin: "g.end",
    attributeName: "cx",
    dur: "0.001s",
    values: "20;4",
    fill: "freeze"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 12,
    r: 3
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "0;h.end",
    attributeName: "cx",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "4;12",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "b.end",
    attributeName: "cx",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "12;20",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "e",
    begin: "d.end",
    attributeName: "r",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "3;0",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "f",
    begin: "e.end",
    attributeName: "cx",
    dur: "0.001s",
    values: "20;4",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "f.end",
    attributeName: "r",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "0;3",
    fill: "freeze"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "0;h.end",
    attributeName: "cx",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "12;20",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "c",
    begin: "b.end",
    attributeName: "r",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "3;0",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "d",
    begin: "c.end",
    attributeName: "cx",
    dur: "0.001s",
    values: "20;4",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "d.end",
    attributeName: "r",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "0;3",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "f.end",
    attributeName: "cx",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "4;12",
    fill: "freeze"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 12,
    r: 3
  }, /*#__PURE__*/React.createElement("animate", {
    id: "a",
    begin: "0;h.end",
    attributeName: "r",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "3;0",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "b",
    begin: "a.end",
    attributeName: "cx",
    dur: "0.001s",
    values: "20;4",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "b.end",
    attributeName: "r",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "0;3",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "e",
    begin: "d.end",
    attributeName: "cx",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "4;12",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "f.end",
    attributeName: "cx",
    calcMode: "spline",
    dur: "0.5s",
    keySplines: ".36,.6,.31,1",
    values: "12;20",
    fill: "freeze"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.d47162e233460a839bc7fe54b14b24f7.svg";
export { ForwardRef as ReactComponent };